import { Link, useLocation, useNavigate } from "react-router-dom";
import i18n from "../../../translate/i18n.jsx";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import pt from "../../../assets/pt.png";
import us from "../../../assets/en.png";

const getSlugKeyFromValue = (value, lng) => {
  const tFunc = i18n.getFixedT(lng);
  const endereco = tFunc("endereco", { returnObjects: true });

  for (const key in endereco) {
    if (endereco[key] === value) {
      return key;
    }
  }
  return null;
};

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isReceitaMenuOpen, setIsReceitaMenuOpen] = useState(false);
  const [lang, setLang] = useState(i18n.language);
  const sidebarRef = useRef(null);

  const [routes, setRoutes] = useState({
    nos: t("endereco.nos"),
    castanha: t("endereco.castanha"),
    producao: t("endereco.producao"),
    receitas_salgadas: t("endereco.receitas_salgadas"),
    receitas_doces: t("endereco.receitas_doces"),
    contato: t("endereco.contato")
  });

  useEffect(() => {
    const updateLanguage = (lng) => {
      setLang(lng);
      setRoutes({
        nos: i18n.getFixedT(lng)("endereco.nos"),
        castanha: i18n.getFixedT(lng)("endereco.castanha"),
        producao: i18n.getFixedT(lng)("endereco.producao"),
        receitas_salgadas: i18n.getFixedT(lng)("endereco.receitas_salgadas"),
        receitas_doces: i18n.getFixedT(lng)("endereco.receitas_doces"),
        contato: i18n.getFixedT(lng)("endereco.contato")
      });
    };

    i18n.on("languageChanged", updateLanguage);
    return () => i18n.off("languageChanged", updateLanguage);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  const handleLanguageChange = (lng) => {
    changeLanguage(lng);

    const pathParts = location.pathname.split("/");
    const currentLang = pathParts[1];
    const currentSlug = pathParts[2];

    if (currentSlug) {
      const slugKey = getSlugKeyFromValue(currentSlug, currentLang);
      const newSlug = slugKey ? i18n.getFixedT(lng)(`endereco.${slugKey}`) : "";
      navigate(newSlug ? `/${lng}/${newSlug}` : `/${lng}`);
    } else {
      navigate(`/${lng}`);
    }

    setIsMobileMenuOpen(false);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const isReceitaActive =
    location.pathname.includes(routes.receitas_salgadas) ||
    location.pathname.includes(routes.receitas_doces);

  return (
    <div className="navbar-container">
      <div className="navbar-links">
        <Link
          to={`/${lang}`}
          className={location.pathname === `/${lang}` ? "active" : ""}
        >
          {t("navbar.home")}
        </Link>

        <Link
          to={`/${lang}/${routes.nos}`}
          className={
            location.pathname === `/${lang}/${routes.nos}` ? "active" : ""
          }
        >
          {t("navbar.saiba mais.nos")}
        </Link>

        <Link
          to={`/${lang}/${routes.castanha}`}
          className={
            location.pathname === `/${lang}/${routes.castanha}` ? "active" : ""
          }
        >
          {t("navbar.saiba mais.castanha")}
        </Link>

        <Link
          to={`/${lang}/${routes.producao}`}
          className={
            location.pathname === `/${lang}/${routes.producao}` ? "active" : ""
          }
        >
          {t("navbar.saiba mais.producao")}
        </Link>

        <div
          className="navbar-item-with-submenu"
          onClick={() => setIsReceitaMenuOpen((prev) => !prev)}
          onMouseLeave={() => setIsReceitaMenuOpen(false)}
        >
          <span className={`receita-toggle ${isReceitaActive ? "active" : ""}`}>
            {t("navbar.receitas.titulo")}
            <span className={`arrow ${isReceitaMenuOpen ? "rotate" : ""}`}>
              ▾
            </span>
          </span>

          {isReceitaMenuOpen && (
            <div className="submenu">
              <Link to={`/${lang}/${routes.receitas_salgadas}`}>
                {t("navbar.receitas.salgadas")}
              </Link>
              <Link to={`/${lang}/${routes.receitas_doces}`}>
                {t("navbar.receitas.doces")}
              </Link>
            </div>
          )}
        </div>

        <Link
          to={`/${lang}/${routes.contato}`}
          className={
            location.pathname === `/${lang}/${routes.contato}` ? "active" : ""
          }
        >
          {t("navbar.contato")}
        </Link>
      </div>

      <div className="language-switcher">
        <img
          src={pt}
          onClick={() => handleLanguageChange("pt")}
          alt="Português"
        />
        <img
          src={us}
          onClick={() => handleLanguageChange("en")}
          alt="English"
        />
      </div>

      <div className="logo-and-toggle">
        <button
          className="menu-toggle"
          onClick={() => setIsMobileMenuOpen((prev) => !prev)}
        >
          ☰
        </button>
      </div>

      {isMobileMenuOpen && (
        <>
          <div className="overlay" onClick={() => setIsMobileMenuOpen(false)} />
          <div className="mobile-sidebar" ref={sidebarRef}>
            <Link
              to={`/${lang}`}
              className={location.pathname === `/${lang}` ? "active" : ""}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t("navbar.home")}
            </Link>
            <Link
              to={`/${lang}/${routes.nos}`}
              className={
                location.pathname === `/${lang}/${routes.nos}` ? "active" : ""
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t("navbar.saiba mais.nos")}
            </Link>

            <Link
              to={`/${lang}/${routes.castanha}`}
              className={
                location.pathname === `/${lang}/${routes.castanha}`
                  ? "active"
                  : ""
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t("navbar.saiba mais.castanha")}
            </Link>

            <Link
              to={`/${lang}/${routes.producao}`}
              className={
                location.pathname === `/${lang}/${routes.producao}`
                  ? "active"
                  : ""
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t("navbar.saiba mais.producao")}
            </Link>

            <div className="navbar-item-with-submenu">
              <button
                className={`receita-toggle ${isReceitaActive ? "active" : ""}`}
                onClick={() => setIsReceitaMenuOpen((prev) => !prev)}
              >
                {t("navbar.receitas.titulo")}
                <span className={`arrow ${isReceitaMenuOpen ? "rotate" : ""}`}>
                  ▾
                </span>
              </button>

              {isReceitaMenuOpen && (
                <div className="mobile-submenu">
                  <Link
                    to={`/${lang}/${routes.receitas_salgadas}`}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {t("navbar.receitas.salgadas")}
                  </Link>
                  <Link
                    to={`/${lang}/${routes.receitas_doces}`}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {t("navbar.receitas.doces")}
                  </Link>
                </div>
              )}
            </div>

            <Link
              to={`/${lang}/${routes.contato}`}
              className={
                location.pathname === `/${lang}/${routes.contato}`
                  ? "active"
                  : ""
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t("navbar.contato")}
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
